import React from "react";
import { geturl } from "../../common/api/SafeClient";

export const WristbandLogin: React.FC = () => {
    window.location.href = geturl("/api/login/wristband");
    return null;
};
